//disabled tickets can be booked by changing their html ticket count or by making them active in html itself right now

import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import CalenderMultiDate from '../desktop/desktopMultiDate';
import LoadingDiv from '../desktop/desktopLoadingDiv';

import locationIcon from '../images/location_icon.png';
import calendarIcon from '../images/calendar_icon.png';
import ticketMinus from '../images/ticket_minus.png';
import ticketPlus from '../images/ticket_plus.png';
import leftArrow from '../images/left_arrow.png';

import Parser from 'html-react-parser';
import swal from 'sweetalert';

class TicketsPage extends Component {
  
  constructor(props) {
    super(props);
    this.page_handler = this.page_handler.bind(this);
    this.getData = this.getData.bind(this);
    this.date_change_handler = this.date_change_handler.bind(this);
    this.state = {
      event_perma: this.props.event_perma,
      page_num: 1,
      post_ticket_array: [],
      order_id: this.props.order_id,
      event_booking: 1, //making default value as 1 so that error is not thrown straight away
      event_name: "",
      event_image: "",
      event_venue_name: "",
      event_locality: "",
      event_city: "",
      occurrence_bit: "",
      event_start_ts: "",
      event_end_ts: "",
      occurrence_id: 0,  //for storing the id of the occurrence that the user selected
      occurrence_date: "0",  //for storing the date of the occurrence that the user selected
      special_note: "",
      event_currency: "",
      event_currency_icon: "",
      event_tc: "",
      module_id: 0,
      api_loaded: 0 //seeing if all the data has been loaded
    };
  }


  componentDidMount(){
    
     if(this.state.api_loaded===0){
      document.getElementById("ticket_page_main_div").style.display = "none";
      document.getElementById("loader-wrapper").style.display = "block";
    }else{
      document.getElementById("ticket_page_main_div").style.display = "block";
      document.getElementById("loader-wrapper").style.display = "none";     
    }   
      fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/event_detail?event_name=" + this.state.event_perma + "&module_type=event&access_token=" + this.props.access_token + "&ticket_token=" + this.props.ticket_token)
        .then(res => res.json())
        .then(
          (result) => {

            let end_ts_time = Math.round((new Date(result['booking_end_time'].replace(' ', 'T') + "+05:30")).getTime()/1000);
            let current_ts_time = Math.round((new Date()).getTime() / 1000);

            if(end_ts_time<current_ts_time){
             alert("Booking for this event is over. You will now be redirected back to the event page.");
             window.location.href = "https://highape.com/"+this.props.city+"/events/"+this.props.event_perma;              
            }else if(result['booking'] !== 1){
             alert("Booking for this event is not available. You will now be redirected back to the event page.");
             window.location.href = "https://highape.com/"+this.props.city+"/events/"+this.props.event_perma;
            }else{
              this.setState({
                event_det_api: 1,
                module_id: result['event_id'],
                event_name: result['event_name'],
                event_booking: result['booking'],
                event_image: result['event_image'],
                event_venue_name: result['venue_name'],
                event_locality: result['venue_location'],
                event_city: result['venue_city'],
                //event_date: result['event_name'],
                occurrence_bit: result['occurence_bit'],
                event_start_ts: result['event_start_ts'],
                event_end_ts: result['event_end_ts'],
                special_note: result['event_note'],
                event_currency: result['currency'],
                event_currency_icon: result['currency_icon'],
                event_tc: result['event_tc']
              });
            }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
          }
        );
      
  }
  

  page_handler() {
          
      document.getElementById("ticket_page_main_div").style.display = "none";
      document.getElementById("loader-wrapper").style.display = "block";
      

    let change_count_array = this.state.post_ticket_array;
    
    if(this.state.order_id !== "0"){
      change_count_array["order_hashed_id"] = this.state.order_id; //changing order id in case available in state so that new order is not created, same order is updated
    }

    change_count_array["occurrence_id"] = this.state.occurrence_id; //setting occurrence id
    
    var ticket_offer_prev_page = [];
    var currency_icon = Parser(this.state.event_currency_icon);
    let total_ticket_count = 0; // to check if atleast 1 ticket has been selected

    for(var i = 0; i < change_count_array["Ticket_Listing"].length; i++) {

    	let ticket_id = change_count_array["Ticket_Listing"][i]["ticket_id"];
      let ticket_count = parseInt(document.getElementById("ticket_count"+ticket_id).innerText, 10);
      
    	change_count_array["Ticket_Listing"][i]["ticket_count"] = ticket_count;

      if(ticket_count>0){
        total_ticket_count = total_ticket_count + ticket_count;
        let ticket_name = document.getElementById("tname_"+ticket_id).innerText;
        let ticket_cost = document.getElementById("tcost_"+ticket_id).innerText;
        ticket_offer_prev_page.push(<p className="selected_tickets_text">{ticket_name} ({currency_icon} {ticket_cost}): {ticket_count} tickets</p>);
      }

    	for(var j = 0; j < change_count_array["Ticket_Listing"][i]["offers"].length; j++) {
    		let offer_id = change_count_array["Ticket_Listing"][i]["offers"][j]["offer_id"];
        
        //checking if the id exists first because if the component was unmounted or the wasnt mounted in the first place, javascipt would throw error as any element with this id wont be there
        var if_div_exists = document.getElementById("addon_count_"+ticket_id+"_"+offer_id);
        if(if_div_exists){
          let offer_count = parseInt(document.getElementById("addon_count_"+ticket_id+"_"+offer_id).innerText, 10);
    		  change_count_array["Ticket_Listing"][i]["offers"][j]["offer_count"] = offer_count;
    	    if(offer_count>0){
            let offer_name = document.getElementById("oname_"+ticket_id+"_"+offer_id).innerText;
            let offer_cost = document.getElementById("ocost_"+ticket_id+"_"+offer_id).innerText;
            ticket_offer_prev_page.push(<p className="selected_offers_text">{offer_name} ({currency_icon} {offer_cost}): {offer_count} offers</p>);
          }

        }else{
          change_count_array["Ticket_Listing"][i]["offers"][j]["offer_count"] = 0;
        }
      }
    }

  //change_count_array["medium"] = this.props.medium;;

    if(this.state.occurrence_bit===1 && this.state.occurrence_id===0){ //if user has not selected a date in multi day event, dont let him proceed
      swal("Please click on Show Dates and select a date first.");
      document.getElementById("loader-wrapper").style.display = "none";
      document.getElementById("ticket_page_main_div").style.display = "block";      
    }else{

      if(total_ticket_count>0){ //calling api and changing page only if atleast one ticket is selected

        var final_tickets_data = JSON.stringify(change_count_array);

      	fetch('https://checkout-api'+this.props.sandbox_url_creator+'.highape.com/web/v1/post_ticket_detail', {
      	    method: 'POST',
      	    headers: {
      	    	'Accept': 'application/json'
      	  	},
         		body: final_tickets_data
       	})
          .then(function(response) {
              return response.json()
          }).then(function(body) {

              change_count_array["order_hashed_id"] = body; //now making the order id as what has been received
          if(body=="0"){
            alert("There seems to be an error with your order. Please refresh the page and try again.");
          }else{
              this.setState({
      		      post_ticket_array: change_count_array,
      		      page_num: 2,
      		      order_id: change_count_array["order_hashed_id"]
      		    });  

            if(this.state.page_num === 2 && this.props.page_number===1){
              document.getElementById("loader-wrapper").style.display = "none";
              document.getElementById("ticket_page_main_div").style.display = "block";
              this.props.main_page_change(this.state.page_num, this.state.module_id, this.state.order_id, this.state.event_name, this.state.event_date, this.state.event_image, this.state.event_venue_name, this.state.event_locality, this.state.event_city, this.state.event_currency, this.state.event_currency_icon, this.state.special_note, this.state.event_tc, ticket_offer_prev_page, this.state.occurrence_date);
            }
          }

          }.bind(this));
      }else{
        swal("Please select atleast 1 ticket to continue.");
        document.getElementById("loader-wrapper").style.display = "none";
        document.getElementById("ticket_page_main_div").style.display = "block";
      }
    }

  }

  getData(data, event_date) {
    this.setState({
      post_ticket_array: data,
      event_date: event_date,
      api_loaded: 1 //this will tell that all the data has been loaded
    });
  }

  date_change_handler(occurrence_id, occurrence_date, end_time) {
    //let occurrence_ts = new Date(occurrence_date);
    let occurrence_ts = new Date(occurrence_date);
    let start_time = occurrence_ts.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
    
    let start_day_num = occurrence_ts.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let start_day = days[start_day_num];
    
    let start_date_num = occurrence_ts.getDate();
    let start_date_month = occurrence_ts.getMonth();
    let start_date_year = occurrence_ts.getYear();
    start_date_year = "20" + (start_date_year - 100);
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let start_month = months[start_date_month];

    let event_date = start_day + ", " + start_date_num + " " + start_month + " " + start_date_year + " (" + start_time + " - " + end_time + ")";

    document.getElementById("date_set_occurrence").innerText = event_date;
    this.setState({
      occurrence_id: occurrence_id,
      occurrence_date: occurrence_date,
      event_date: event_date
    });
  }
  
  componentDidUpdate(props) {
    if(this.state.api_loaded===0){
      document.getElementById("ticket_page_main_div").style.display = "none";
      document.getElementById("loader-wrapper").style.display = "block";
    }else{
      document.getElementById("ticket_page_main_div").style.display = "block";
      document.getElementById("loader-wrapper").style.display = "none";     
    }
  }


  render() {

    //let start_ts = new Date(this.state.event_start_ts);
    //let end_ts = new Date(this.state.event_end_ts);
    let start_ts = new Date(this.state.event_start_ts.replace(' ', 'T') + "+05:30");
    let end_ts = new Date(this.state.event_end_ts.replace(' ', 'T') + "+05:30");
    let start_date = start_ts.toDateString();
    
    let start_day_num = start_ts.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let start_day = days[start_day_num];
    
    let start_date_num = start_ts.getDate();
    let start_date_month = start_ts.getMonth();
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let start_month = months[start_date_month];
    let start_date_year = start_ts.getYear();
    start_date_year = "20" + (start_date_year - 100);

    let end_date = end_ts.toDateString();
    let event_date = "";
    let occurrence_date = "";
    let end_time = ""; //to be sent seperately for occurrence events

    if(this.state.occurrence_bit === 1){

      let start_time = start_ts.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      end_time = end_ts.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      event_date = "Multiple Days (" + start_time + " - " + end_time + ")";

    }else{

      let start_time = start_ts.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      end_time = end_ts.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
      event_date = start_day + ", " + start_date_num + " " + start_month + " " + start_date_year + " (" + start_time + " onwards)";

    }

    if(this.state.occurrence_date==="0"){
      occurrence_date = start_date;
    }else{
      occurrence_date = this.state.occurrence_date;
    }

    var event_link_footer = "https://highape.com/"+this.props.city+"/events/"+this.props.event_perma+"?utm_source=checkout_back"; //this is the event link

      return (
        <div>
        <LoadingDiv />
        <div id="ticket_page_main_div">
          <div className={this.props.name_of_class}>
            <EventDetails sandbox_url_creator={this.props.sandbox_url_creator} event_perma={this.state.event_perma} access_token={this.props.access_token} occurrence_bit={this.state.occurrence_bit} date_changer={this.date_change_handler} event_name={this.state.event_name} venue_name={this.state.event_venue_name} event_locality={this.state.event_locality} event_city={this.state.event_city} occurrence_date={occurrence_date} start_date={start_date} end_date={end_date} event_date={event_date} end_time={end_time}/>
            <BlankSpace blank_space_css_count="1"/>
            <AllPhaseTickets sandbox_url_creator={this.props.sandbox_url_creator} access_token={this.props.access_token} ticket_token={this.props.ticket_token} event_currency_icon={this.state.event_currency_icon} event_perma={this.state.event_perma} source={this.props.source} medium={this.props.medium} campaign={this.props.campaign} lat={this.props.lat} lng={this.props.lng} sendTicketsDateToParent={this.getData} event_date={event_date}/>
            <FooterTickets event_link_footer={event_link_footer} event_currency_icon={this.state.event_currency_icon} page_change={this.page_handler} />
          </div>
          <div className={this.props.name_of_ticket_btn_class}>
            <div className="col-sm-8 col-sm-offset-2 col-xs-6 continue_right_side" onClick={this.page_handler} >
              Continue
            </div>
            <div className="clearfix"></div>
            <div className="ticket_desktop_footer col-sm-12 col-xs-12">
              <div className="col-sm-4 col-xs-4 col-sm-offset-2 col-xs-offset-2 padding_set_0">
                <p className="below_continue_back_tickets_desktop"><a href={event_link_footer}><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>See event details</a></p>
              </div>
              <div id="lowest_price_image" className="col-sm-5 col-xs-5 padding_set_0">
                <img src="https://res.cloudinary.com/https-highape-com/image/upload/h_100/v1545046344/Lowest_afjscf.png" alt="Lowest Price Guarantee" className="img_lowest_price" />
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
        </div>
      );
  }
}

class EventDetails extends Component {

  constructor() {
    super();
    this.state = {
      error: null,
      childVisible: true,
    }
  }

  componentDidMount(){

  }
  

  render() {
    
    if(this.props.occurrence_bit === 1){
      return (
        <div className="event_details">
          <div className="col-sm-12 col-xs-12">
            <div className="event_title">
              {this.props.event_name}
            </div>
            <div className="venue_name event_details_det">
              <img className="location_icon" alt="Icon for Location" src={locationIcon} />  {this.props.venue_name} • {this.props.event_locality} • {this.props.event_city}
            </div>
          </div>
          <div className="col-sm-12 col-xs-12">
          <div className="dates_show event_details_det col-sm-12 col-xs-12">
            <img className="calendar_icon" alt="Icon for Calendar" src={calendarIcon} /> <span id="date_set_occurrence">{this.props.event_date}</span>
          </div>

          <div id="show_dates_title" className="show_other_dates col-sm-12 col-xs-12" onClick={() => this.onClickDates()}>
          {
            this.state.childVisible
              ? <span>Hide Available Dates</span>
              : <span>Show Available Dates</span>
          }
          </div>
          <div className="col-sm-12 col-xs-12 calendar_div_dates">
          {
            this.state.childVisible
              ? <CalenderMultiDate sandbox_url_creator={this.props.sandbox_url_creator} access_token={this.props.access_token} event_perma={this.props.event_perma} occurrence_date={this.props.occurrence_date} min_date={this.props.start_date} max_date={this.props.end_date} end_time={this.props.end_time} date_change={this.props.date_changer} />
              : null
          }
          </div>
          </div>
          <div className="clearfix"></div>
        </div>
      );
    }else{
      return (
        <div className="event_details">
          <div className="col-sm-12 col-xs-12">
            <div className="event_title">
              {this.props.event_name}
            </div>
            <div className="venue_name event_details_det">
              <img className="location_icon" alt="Icon for Location" src={locationIcon} />  {this.props.venue_name} • {this.props.event_locality} • {this.props.event_city}
            </div>
          </div>
          <div className="col-sm-12 col-xs-12">
          <div className="dates_show event_details_det col-sm-12 col-xs-12">
            <img className="calendar_icon" alt="Icon for Calendar" src={calendarIcon} /> {this.props.event_date}
          </div>
          </div>
          <div className="clearfix"></div>
        </div>
      );
    }
  }

  onClickDates() {
    this.setState(prevState => ({ childVisible: !prevState.childVisible }));
  }
}


class BlankSpace extends Component {
  render() {
    let name_of_class = "blank_desk_space" + this.props.blank_space_css_count;
    return (
      <div className={name_of_class}>
      </div>
    );
  }
}


class AllPhaseTickets extends Component {

  constructor() {
    super();
    this.state = {
      childVisible: false,
      ticket_list_div: "",
      post_ticket_array: []
    }
  }

  componentDidMount(){
  	 fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/ticket_offer_detail?event_name=" + this.props.event_perma + "&module_type=event&access_token="+this.props.access_token+"&ticket_token=" + this.props.ticket_token)
      .then(res => res.json())
      .then(
        (result) => {
        
          var phase_array = result['Phases_listing'];
          var temp_ticket_list_div = [];
          var post_ticket_ids = [];
          var show_lowest_price_image = 0;
          for(var p = 0; p<phase_array.length; p++){
              var phase_start = 0; //make it 0 everytime the phase loop runs, is used later for naming the phase
              //for storing ticket details in the post request that will be made with ticket and offer counts
              let temp_phase_power_bit = phase_array[p]["power_bit"];
              let temp_phase_active_bit = phase_array[p]["active_bit"];
              let urgency_text_phase = "";
              if(temp_phase_power_bit===3){
               	urgency_text_phase = phase_array[p]["phase_urgency_text"];
              }
              if(temp_phase_power_bit===2){
                urgency_text_phase = "Sold Out!";
              }
              var ticket_array = result['Phases_listing'][p]['Tickets_listing'];
    		    for(var i = 0; i < ticket_array.length; i++) {
    		       let temp_ticket_id = ticket_array[i]["id"];
    		       let ticket_count_id = "ticket_count" + temp_ticket_id;
    		       let add_on_div_id = "add_on_div" + temp_ticket_id;
    		       let offers_array = ticket_array[i]["Offers_listing"];
               	   let offer_count_for_ticket = "o_" + temp_ticket_id;
               	   let ticket_name_id = "tname_" + temp_ticket_id;
                   let ticket_cost_id = "tcost_" + temp_ticket_id;

                   var post_offer_ids = [];
                   let ticket_parent_id = "parent_t_" + temp_ticket_id;

                   let cost_of_ticket = ticket_array[i]["cost"];
                   let ticket_striked_cost = ticket_array[i]["striked_cost"];

                   let ticket_striked_div = [];
            		if(cost_of_ticket < ticket_striked_cost){
            			ticket_striked_div.push(<span className="striked_cost_ticket"><strike>{ticket_striked_cost}</strike></span>);
            		}

                if(cost_of_ticket > 0){
                  show_lowest_price_image = 1;
                }

                   let minus_ticket_css = "minus_ticket";
                   let plus_ticket_css = "plus_ticket";
                   let temp_power_bit = ticket_array[i]["ticket_power_bit"];
                   let urgency_text_ticket = "";
                   if(temp_power_bit===3){
                   	urgency_text_ticket = ticket_array[i]["urgency_text"];
                   }
                   if(temp_power_bit===2 || temp_phase_power_bit === 2 || temp_phase_active_bit === 0){
                    if(temp_power_bit===2){ //adding urgency text only if ticket power bit is 2
                      urgency_text_ticket = "Sold Out!";
                    }
                    if(temp_phase_power_bit === 2 || temp_phase_active_bit === 0){
                      temp_power_bit = 2 //if phase is non bookable then changing ticket power bit here, this will be used to make ticket non bookable
                    }
                    minus_ticket_css = "minus_ticket ticket_disabled";
                    plus_ticket_css = "plus_ticket ticket_disabled";
                   }

    		       //for storing offer details in the post request that will be made with ticket and offer counts
    		       let no_offers = offers_array.length;

    	    			for(var j = 0; j < no_offers; j++) {
    	    				let offer_id = offers_array[j]["offer_id"];
    	    				if(j===no_offers-1){
    	    					post_offer_ids.push({"offer_id": offer_id, "offer_count": 0 });
    	    				}else{
    	    					post_offer_ids.push({"offer_id": offer_id, "offer_count": 0 },);
    	    				}
    	    			}

    	    			  if(i===ticket_array.length-1){
    		      		 	post_ticket_ids.push({"ticket_id": temp_ticket_id, "ticket_count": 0, "offers": post_offer_ids});
    		      		}else{
    		      			post_ticket_ids.push({"ticket_id": temp_ticket_id, "ticket_count": 0, "offers": post_offer_ids},);
    		      		}

                  let currency_icon = Parser(this.props.event_currency_icon);

              if(phase_array.length === 1){ //in case of single phase tickets

                 temp_ticket_list_div.push(<div key={ticket_parent_id} id={ticket_parent_id} className="single_ticket_div"><div className="clearfix"></div><div className="col-sm-8 col-xs-8">
                                  <span id={ticket_name_id} className="ticket_name">{ticket_array[i]["name"]}</span>
                                  <span className="ticket_currency_icon">{currency_icon}</span>{ticket_striked_div}<span id={ticket_cost_id} className="ticket_price">{cost_of_ticket}</span>
                                </div>
                                <div className="col-sm-4 col-xs-4 ticket_div_desktop">
                                  <img src={ticketMinus} alt="Minus Symbol For Ticket" className={minus_ticket_css} onClick={() => this.onClickMinusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                  <span className="ticket_count" id={ticket_count_id}>0</span>
                                  <img src={ticketPlus} alt="Plus Symbol for Ticket" className={plus_ticket_css} onClick={() => this.onClickPlusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                </div>
                                <div className="col-sm-12 col-xs-12 urgency_text_ticket_desktop">
                                {urgency_text_ticket}
                                </div>
                                <div className="col-sm-9 col-xs-9">
                                  <span className="ticket_description">{ticket_array[i]["notes"]}</span>
                                </div>
                                <div className="clearfix"></div>
                                <input className="hidden_div" id={offer_count_for_ticket} defaultValue="0" />
                                <div className="add_on_div" id={add_on_div_id}></div>
                                <div className="clearfix"></div>
                                </div>);

              }else{ //in case of multi phase tickets

                if(phase_start===0){
                  phase_start = 1; //now changing phase_start value so that for another ticket, it goes into the else loop
                  temp_ticket_list_div.push(<div><div className="clearfix"></div>
                  				<div className="col-sm-3 col-xs-3 phase_title">
                  					{phase_array[p]["name"]}
                  				<div className="col-sm-12 col-xs-12 urgency_text_phase_desktop">
                                	{urgency_text_phase}
                                </div>
                  				</div>
                                <div key={ticket_parent_id} id={ticket_parent_id} className="single_ticket_div padding_bottom col-sm-9 col-xs-9">
                                <div className="col-sm-6 col-xs-6">
                                  <span id={ticket_name_id} className="ticket_name">{ticket_array[i]["name"]}</span>
                                  <span className="ticket_currency_icon">{currency_icon}</span>{ticket_striked_div}<span id={ticket_cost_id} className="ticket_price">{ticket_array[i]["cost"]}</span>
                                </div>
                                <div className="col-sm-6 col-xs-6 ticket_div_desktop">
                                  <img src={ticketMinus} alt="Minus Symbol For Ticket" className={minus_ticket_css} onClick={() => this.onClickMinusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                  <span className="ticket_count" id={ticket_count_id}>0</span>
                                  <img src={ticketPlus} alt="Plus Symbol for Ticket" className={plus_ticket_css} onClick={() => this.onClickPlusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                </div>
                                <div className="col-sm-12 col-xs-12 urgency_text_ticket_desktop">
                                {urgency_text_ticket}
                                </div>                                
                                <div className="col-sm-12 col-xs-12">
                                  <span className="ticket_description">{ticket_array[i]["notes"]}</span>
                                </div>
                                </div>
                                <div className="clearfix"></div>
                                <input className="hidden_div" id={offer_count_for_ticket} value="0" />
                                <div className="add_on_div2" id={add_on_div_id}></div>
                                <div className="clearfix"></div>
                                <div className="clearfix"></div>
                                </div>);  

                }else{

                  temp_ticket_list_div.push(<div><div className="clearfix"></div><div className="col-sm-3 col-xs-3"></div>
                                <div key={ticket_parent_id} id={ticket_parent_id} className="single_ticket_div padding_bottom col-sm-9 col-xs-9">
                                <div className="col-sm-6 col-xs-6">
                                  <span id={ticket_name_id} className="ticket_name">{ticket_array[i]["name"]}</span>
                                  <span className="ticket_currency_icon">{currency_icon}</span>{ticket_striked_div}<span id={ticket_cost_id} className="ticket_price">{ticket_array[i]["cost"]}</span>
                                </div>
                                <div className="col-sm-6 col-xs-6 ticket_div_desktop">
                                  <img src={ticketMinus} alt="Minus Symbol For Ticket" className={minus_ticket_css} onClick={() => this.onClickMinusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                  <span className="ticket_count" id={ticket_count_id}>0</span>
                                  <img src={ticketPlus} alt="Plus Symbol For Ticket" className={plus_ticket_css} onClick={() => this.onClickPlusTicket(temp_ticket_id, offers_array, cost_of_ticket, temp_power_bit)} />
                                </div>
                                <div className="col-sm-12 col-xs-12 urgency_text_ticket_desktop">
                                {urgency_text_ticket}
                                </div>                                
                                <div className="col-sm-12 col-xs-12">
                                  <span className="ticket_description">{ticket_array[i]["notes"]}</span>
                                </div>
                                </div>
                                <div className="clearfix"></div>
                                <input className="hidden_div" id={offer_count_for_ticket} value="0" />
                                <div className="add_on_div2" id={add_on_div_id}></div>
                                <div className="clearfix"></div>
                                <div className="clearfix"></div>
                                </div>);

                }
              }

            }
          }

        if(show_lowest_price_image === 1){
          document.getElementById("lowest_price_image").style.display = "block";
        }
        

		    this.setState({
		      ticket_list_div: temp_ticket_list_div,
          post_ticket_array: {"access_token": this.props.access_token, "ticket_token": this.props.ticket_token, "module_type": "event", "event_id": result["event_id"], "source": this.props.source, "medium": this.props.medium, "campaign": this.props.campaign, "occurrence_id": 0, "order_hashed_id": "0", "lat": 0, "lng": 0, "book_source": 0, "Ticket_Listing": post_ticket_ids}
       
		    });
		    //this.setState({
		      //post_ticket_array: {"access_token": "7d45426c7fb9f9470d1cf0ef2d23b524", "event_id": result["event_id"], "occurrence_id": 0, "order_hashed_id": "0", "lat": 0, "lng": 0, "book_source": 1, "Ticket_Listing": post_ticket_ids}
		    //});
		    this.props.sendTicketsDateToParent(this.state.post_ticket_array, this.props.event_date);

        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          //alert(error);
        }
      );
  }
  
  render() {
    
    //for some reason, the rendering process is happening three times, check it, can check by putting a alert box here
    return (
      <div className="col-sm-12 single_phase_desk_tickets">
        {this.state.ticket_list_div}
      </div>
    );
  }

  onClickPlusTicket(ticket_id, offers_array, ticket_cost, temp_power_bit) {
    if(temp_power_bit !== 2){ //not allowing update of count in case sold out
      
      var current_ticket_count = document.getElementById("ticket_count"+ticket_id).innerText; //the existing ticket count
      let add_on_div_id = "add_on_div" + ticket_id; //defining  a particular add_on div for a particular ticket id
      let no_offers = offers_array.length;

      if(no_offers>0){ //building add-on component only if there are any offers for this ticket
      	const add_on_def = <SinglePhaseAddOns event_currency_icon={this.props.event_currency_icon}  ticket_id={ticket_id} offers_array={offers_array} />; //Defining the component for add on here with the ticket id for which it is to be displayed
      	ReactDOM.render(add_on_def, document.getElementById(add_on_div_id)); //Rendering the add_on tickets here
  	  }
        
        if(current_ticket_count<10){
          //change total cost of  tickets and offers in footer
          let current_total_cost = parseInt(document.getElementById("total_amount_tickets").innerText, 10);
          current_total_cost = current_total_cost + parseInt(ticket_cost, 10);
          document.getElementById("total_amount_tickets").innerText = current_total_cost;
          //changing ticket count now
          current_ticket_count++;
          document.getElementById("ticket_count"+ticket_id).innerText = current_ticket_count;
        }
    }
  }

  onClickMinusTicket(ticket_id, offers_array, ticket_cost, temp_power_bit) {
    if(temp_power_bit !== 2){ //not allowing update of count in case sold out
      var current_ticket_count = document.getElementById("ticket_count"+ticket_id).innerText;
      let add_on_div_id = "add_on_div" + ticket_id; //defining  a particular add_on div for a particular ticket id
        if(current_ticket_count>0){
          //change total cost of  tickets and offers in footer
          let current_total_cost = parseInt(document.getElementById("total_amount_tickets").innerText, 10);
          current_total_cost = current_total_cost - parseInt(ticket_cost, 10);
          document.getElementById("total_amount_tickets").innerText = current_total_cost;
          //changing ticket count now
          current_ticket_count--;
          document.getElementById("ticket_count"+ticket_id).innerText = current_ticket_count;
          if(current_ticket_count === 0){
            document.getElementById("total_amount_tickets").innerText = current_total_cost - parseInt(document.getElementById("o_" + ticket_id).value, 10); //decreasing the full cost of addon offers for this ticket
            ReactDOM.unmountComponentAtNode(document.getElementById(add_on_div_id)); //unmounting the component
          }
        }
    }
  }
}

class SinglePhaseAddOns extends Component {

  render() {

    var addon_list_div = [];
    
    let add_on_array = this.props.offers_array
    let ticket_id = this.props.ticket_id;
    
    let no_offers = add_on_array.length;
    let offer_loop_start = 0; //checked to add add-ons title
	    for(var j = 0; j < no_offers; j++) { 

	      let add_on_ticket_id = add_on_array[j]["offer_id"];
	      let addon_count_id = "addon_count_" + ticket_id + "_" + add_on_ticket_id;
          let add_on_cost = add_on_array[j]["offer_cost"];
          let add_on_striked_cost = add_on_array[j]["offer_striked_cost"];

          let offer_name_id = "oname_" + ticket_id + "_" + add_on_ticket_id;
          let offer_cost_id = "ocost_" + ticket_id + "_" + add_on_ticket_id;
          let currency_icon = Parser(this.props.event_currency_icon);

          let striked_div = [];
            if(add_on_cost < add_on_striked_cost){
              striked_div.push(<span className="striked_cost_addon"><strike>{add_on_striked_cost}</strike></span>);
            }
          
          let minus_ticket_addon_css = "minus_ticket";
          let plus_ticket_addon_css = "plus_ticket";  
          
          let temp_addon_power_bit = add_on_array[j]["offer_power_bit"];
          let temp_addon_status = add_on_array[j]["offer_status"];
          let urgency_text_addon = "";
          if(temp_addon_power_bit===3){
           	urgency_text_addon = add_on_array[j]["offer_urgency_text"];
          }
          if(temp_addon_power_bit===2 || temp_addon_status===0){
            if(temp_addon_power_bit===2){ //showing urgency text as sold out only if power bit set as 2
              urgency_text_addon = "Sold Out!";
            }
            temp_addon_power_bit = 2; //now setting power bit 2, in case of status = 0 also,  this will be used to make offer non bookable
            minus_ticket_addon_css = "minus_ticket ticket_disabled";
            plus_ticket_addon_css = "plus_ticket ticket_disabled";
          }

            if(offer_loop_start>0){
              addon_list_div.push( <div>
                                    <div className="col-sm-12 col-xs-12 single_phase_addons">
                                    <div className="col-sm-3 col-xs-3">
                                    </div>
                                    <div className="col-sm-9 col-xs-9">
                                      <div className="col-sm-6 col-xs-6 add_on_name_cost">
                                        <span id={offer_name_id} className="ticket_single_phase_addons">{add_on_array[j]["offer_name"]}</span>
                                        <span className="offer_currency_icon">{currency_icon}</span>{striked_div}<span id={offer_cost_id} className="ticket_cost_addons">{add_on_cost}</span>
                                      </div>
                                      <div className="col-sm-6 col-xs-6 plus_minus_addons ticket_div_desktop">
                                        <img src={ticketMinus} alt="Minus Symbol For Ticket" className={minus_ticket_addon_css} onClick={() => this.onClickMinusAddon(ticket_id, add_on_ticket_id, add_on_cost, temp_addon_power_bit)} />
                                        <span className="single_phase_ticket_count" id={addon_count_id}>0</span>
                                        <img src={ticketPlus} alt="Plus Symbol For Ticket" className={plus_ticket_addon_css} onClick={() => this.onClickPlusAddon(ticket_id, add_on_ticket_id, add_on_cost, temp_addon_power_bit)} />
                                      </div>
                                		<div className="col-sm-12 col-xs-12 urgency_text_addon_desktop">
                                			{urgency_text_addon}
                                		</div>                                 
                                      <div className="col-sm-12 col-xs-12 add_on_desc_css">
                                        <span className="desc_single_phase_addons">{add_on_array[j]["offer_special_details"]}</span>
                                      </div>
                                    </div>
                                  </div>
                                 </div>);
            }else{
  	          addon_list_div.push( <div>
  	                                <div className="col-sm-12 col-xs-12 single_phase_addons">
  	                                <div className="col-sm-3 col-xs-3 add_on_right_border">
  	                                  <span className="title_single_phase_addons">Add-Ons:</span>
  	                                  <span className="desc_single_phase_addons">You can add these to get benefits</span>
  	                                </div>
                                    <div className="col-sm-9 col-xs-9">
                                      <div className="col-sm-6 col-xs-6 add_on_name_cost">
                                        <span id={offer_name_id} className="ticket_single_phase_addons">{add_on_array[j]["offer_name"]}</span>
                                        <span className="offer_currency_icon">{currency_icon}</span>{striked_div}<span id={offer_cost_id} className="ticket_cost_addons">{add_on_array[j]["offer_cost"]}</span>
                                      </div>
                                      <div className="col-sm-6 col-xs-6 plus_minus_addons ticket_div_desktop">
                                        <img src={ticketMinus} alt="Minus Symbol for Ticket" className={minus_ticket_addon_css} onClick={() => this.onClickMinusAddon(ticket_id, add_on_ticket_id, add_on_cost, temp_addon_power_bit)} />
                                        <span className="single_phase_ticket_count" id={addon_count_id}>0</span>
                                        <img src={ticketPlus} alt="Plus Symbol for Ticket" className={plus_ticket_addon_css} onClick={() => this.onClickPlusAddon(ticket_id, add_on_ticket_id, add_on_cost, temp_addon_power_bit)} />
                                      </div>
                                		<div className="col-sm-12 col-xs-12 urgency_text_addon_desktop">
                                			{urgency_text_addon}
                                		</div>                                      
                                      <div className="col-sm-12 col-xs-12 add_on_desc_css">
                                        <span className="desc_single_phase_addons">{add_on_array[j]["offer_special_details"]}</span>
                                      </div>
                                    </div>
  	                              </div>
  	                             </div>);

              offer_loop_start++;
            }
          }
	    
	      return (
	        <div>{addon_list_div}</div>
	      );
    }
  


  onClickPlusAddon(ticket_id, addon_id, add_on_cost, temp_addon_power_bit) {
    if(temp_addon_power_bit !== 2) { //not changing in case offer sold out
      var current_addon_count = document.getElementById("addon_count_" + ticket_id + "_" + addon_id).innerText; //the existing addon count
    
      if(current_addon_count<10){
        //change total cost of tickets and offers in footer
        let current_total_cost = parseInt(document.getElementById("total_amount_tickets").innerText, 10);
        current_total_cost = current_total_cost + parseInt(add_on_cost, 10);
        document.getElementById("total_amount_tickets").innerText = current_total_cost;
        //changing ticket count now
        current_addon_count++;
        document.getElementById("addon_count_" + ticket_id + "_" + addon_id).innerText = current_addon_count;

        document.getElementById("o_" + ticket_id).value = parseInt(add_on_cost, 10) + parseInt(document.getElementById("o_" + ticket_id).value, 10);
      }
    }
  }

  onClickMinusAddon(ticket_id, addon_id, add_on_cost, temp_addon_power_bit) {
    if(temp_addon_power_bit !== 2) { //not changing in case offer sold out
      var current_addon_count = document.getElementById("addon_count_" + ticket_id + "_" + addon_id).innerText;

        if(current_addon_count>0){
          //change total cost of tickets and offers in footer
          let current_total_cost = parseInt(document.getElementById("total_amount_tickets").innerText, 10);
          current_total_cost = current_total_cost - parseInt(add_on_cost, 10);
          document.getElementById("total_amount_tickets").innerText = current_total_cost;
          //changing ticket count now
          current_addon_count--;
          document.getElementById("addon_count_" + ticket_id + "_" + addon_id).innerText = current_addon_count;

          document.getElementById("o_" + ticket_id).value = parseInt(document.getElementById("o_" + ticket_id).value, 10) - parseInt(add_on_cost, 10);
        }
    }
  }
}

class FooterTickets extends Component {

  render() {
    var currency_icon = Parser(this.props.event_currency_icon);
    return (
      <div>
        <div className="col-sm-12 col-xs-12">
          <div className="col-sm-12 col-xs-12 total_amount_next_ticket_desk">
            <span className="total_amount_text">Total:</span>
            <span className="total_amount_number_desktop"><span>{currency_icon} </span><span id="total_amount_tickets">0</span></span>
          </div>
          <div className="col-sm-8 col-sm-offset-2 col-xs-6 next_ticket_click_desktop" onClick={this.props.page_change} >
            Continue
          </div>
        </div>
        <div className="ticket_desktop_footer col-sm-12 col-xs-12">
            <p className="see_event_details_desktop"><a href={this.props.event_link_footer}><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>See event details</a></p>
        </div>
      </div>
    );
  }

}

export default TicketsPage;


// WEBPACK FOOTER //
// ./src/desktop/desktopTicketsPage.js